import { Outlet } from "react-router-dom";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { AlertProvider } from "../../../app/AlertProvider";
import AlertModal from "../../../components/others/AlertModal";
import { FranchiseLogo } from "../../../components/others/FranchiseBranding";
import { RootState } from "../../../store/combineReducer";
import { isFranchiseTenant } from "../../../utils/franchise/franchiseAbsenteeismMenu";

export default function Add() {
  const franchiseState = useSelector((state: RootState) => state.franchise);
  const franchiseLayout = isFranchiseTenant(franchiseState);

  return (
    <AlertProvider>
      <div className={`login${franchiseLayout ? " login--franchise" : ""}`}>
        {!franchiseLayout && <div className="messages_slide" />}
        <div className="login_right">
          <div className="company_logo">
            <FranchiseLogo className="logo" linkToHome={false} />
            <p>Portal de clientes</p>
            {franchiseLayout && (
              <p className="login-franchise-name">
                {franchiseState.branding?.fantasyName ||
                  franchiseState.branding?.name ||
                  franchiseState.slug}
              </p>
            )}
          </div>

          <div className="register-form" style={{ width: "100%", maxHeight: "100vh", overflow: "auto" }}>
            <Outlet />
          </div>

          <div className="new_clients">
            <p>
              ¿Ya tienes un usuario?{" "}
              <Link to="/login">
                Inicia sesión aquí
              </Link>
            </p>
          </div>
        </div>
      </div>
      <AlertModal />
    </AlertProvider>
  );
}
